const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaFlashFill0\"><g id=\"evaFlashFill1\"><path id=\"evaFlashFill2\" fill=\"currentColor\" d=\"M11.11 23a1 1 0 0 1-.34-.06a1 1 0 0 1-.65-1.05l.77-7.09H5a1 1 0 0 1-.83-1.56l7.89-11.8a1 1 0 0 1 1.17-.38a1 1 0 0 1 .65 1l-.77 7.14H19a1 1 0 0 1 .83 1.56l-7.89 11.8a1 1 0 0 1-.83.44Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
